import { render } from "./TransliterationKey.vue?vue&type=template&id=b6d61ba0&ts=true"
import script from "./TransliterationKey.vue?vue&type=script&lang=ts"
export * from "./TransliterationKey.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__